import styled, { css } from 'styled-components';
import { statusColors } from 'syf-component-library/defaultTheme';
import { StyledFlex } from '../../../styles/common';
import { StyledText } from '../../../styles/text';
import { spacing } from '../../../styles/theme';
const badgeStyles = css `
  width: 3em;
  height: 3em;
  border-radius: 50%;
  background-color: ${statusColors.info.background};
`;
export const StyledIconContainer = styled(StyledFlex) `
  margin-bottom: ${props => !props.badge && `${spacing.xsmall}px`};

  ${props => props.badge && badgeStyles}

  > svg {
    font-size: 18px;
    height: ${props => props.badge && '24px'};
  }
`;
export const StyledIconText = styled(StyledText) `
  font-size: 10px;
`;
//# sourceMappingURL=subcomponents.js.map